import { FC, ReactNode } from 'react';
import { HTMLRenderer } from '../HTMLRenderer/HTMLRenderer';
import { css } from '@bts-web/utils-style-engine';

const QuestionnaireOrFeatureTitleAndDescription: FC<{
  title?: string | null;
  subtitle?: string | null;
  description?: string | null;
  subtitleChildren?: ReactNode;
}> = ({ subtitle, title, description, subtitleChildren }) => {
  return (
    <div
      aria-label="intro section"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        mx: 'auto',
        width: 'calc(100% - var(--sizes-extra_large_2))',
        gap: 'small',
      })}
    >
      {title && (
        <h1
          className={css({
            lineHeight: 'headline.large_semi_bold',
            letterSpacing: 'headline.large_semi_bold',
            color: 'neutrals.text_primary',
            fontSize: 'headline.large_semi_bold',
            fontWeight: 'headline.large_semi_bold',
          })}
          aria-label="title"
        >
          <HTMLRenderer>{title}</HTMLRenderer>
        </h1>
      )}

      {subtitle && (
        <h5
          className={css({
            color: 'neutrals.text_secondary',
            fontSize: 'body.medium',
            fontWeight: 'body.medium',
            letterSpacing: 'body.medium',
            lineHeight: 'body.medium',
            whiteSpace: 'pre-line',

            '& #net-assets-drawer-trigger, & #high-risk-investments-drawer-trigger':
              {
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
                cursor: 'pointer',
                color: 'neutrals.text_primary',
                display: 'inline-block',
              },
          })}
          aria-label="subtitle"
        >
          <HTMLRenderer>{subtitle}</HTMLRenderer>
          {subtitleChildren}
        </h5>
      )}

      {description && (
        <h5
          className={css({
            color: 'neutrals.text_primary',
            fontSize: 'body.medium',
            lineHeight: 'body.medium',
            letterSpacing: 'body.medium',
            fontWeight: 'body.medium',
            whiteSpace: 'pre-line',
          })}
          aria-label="description"
        >
          <HTMLRenderer>{description}</HTMLRenderer>
        </h5>
      )}
    </div>
  );
};

export { QuestionnaireOrFeatureTitleAndDescription };
